function search() {
  return {
    cachedResults: {},
    loading: false,
    hasSearched: false,
    searchTerm: "",
    abortController: null,
    results: [],
    totalResults: 0,

    init() {
      this.abortController = new AbortController();
    },

    onChange() {
      const newSearchTerm = this.getQuery();
      if (newSearchTerm.length > 0) {
        this.getSearchResults(newSearchTerm);
      } else {
        this.clearResults();
      }
    },

    onKeyup(event) {
      event.preventDefault();
      const newSearchTerm = this.getQuery();

      switch (event.code) {
        case "ArrowUp":
          break;
        case "ArrowDown":
          break;
        case "Enter":
          break;
        case "Escape":
          this.$dispatch("toggle-search");
          this.clearResults();
          break;
        default:
          if (newSearchTerm.length > 0) {
            this.getSearchResults(newSearchTerm);
          } else {
            this.clearResults();
          }
          break;
      }
    },

    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },

    getQuery() {
      return this.searchTerm.trim();
    },

    clearResults() {
      this.results = [];
      this.totalResults = 0;
      const predictiveSearchResults = document.querySelector(".search-result");
      if (predictiveSearchResults) {
        predictiveSearchResults.innerHTML = "";
      }
    },

    async getSearchResults(searchTerm) {
      // Early return if search term is empty
      if (!searchTerm || searchTerm.trim().length === 0) {
        this.clearResults();
        return;
      }

      const queryKey = searchTerm.replace(" ", "-").toLowerCase();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      this.loading = true;

      try {
        const response = await fetch(
          `${window.routes.predictive_search_url}?q=${encodeURIComponent(
            searchTerm
          )}&section_id=predictive-search&resources[type]=product,page,collection,article,query&resources[options][fields]=title,product_type,variants.title,tag`,
          {
            signal: this.abortController.signal
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const text = await response.text();
        const parser = new DOMParser();
        const documentParsed = parser.parseFromString(text, "text/html");
        const resultsSection = documentParsed.querySelector("#shopify-section-predictive-search");

        if (resultsSection) {
          this.cachedResults[queryKey] = resultsSection.innerHTML;
          this.renderSearchResults(resultsSection.innerHTML);
        } else {
          this.clearResults();
        }
      } catch (error) {
        if (error?.code === 20) {
          return;
        }

        console.error("Search error:", error);
        this.clearResults();
      } finally {
        this.loading = false;
      }
    },

    renderSearchResults(resultsMarkup) {
      this.hasSearched = true;
      const predictiveSearchResults = document.querySelector(".search-result");
      if (predictiveSearchResults) {
        predictiveSearchResults.innerHTML = resultsMarkup;

        this.totalResults = Array.from(predictiveSearchResults.querySelectorAll('[role="option"]')).filter(
          (el) => el.offsetParent !== null
        ).length;
      } else {
        this.totalResults = 0;
      }
    },

    clearSearchTerm() {
      this.searchTerm = "";
      this.clearResults();
    },

    get showPopular() {
      return !this.hasSearched || (this.hasSearched && this.totalResults === 0);
    }
  };
}

export default search;
